import { FC, useCallback, useState } from "react";
import { useAppSelector } from "@/store/hooks";
import { savingsOpportunitiesTopOpportunitiesGroupedDataSelector } from "@/store/savings-opportunities/selectors/savingsOpportunitiesTopOpportunitiesGroupedDataSelector";
import { AllPossibleTopOpportunitiesOptionsType } from "@/components/pages/common/opportunities/utils/types/types";
import { TopOpportunities } from "@/components/pages/common/opportunities/components/metadata/top-opportunities/TopOpportunities";
import { getTopOpportunitiesFittingCount } from "@/components/pages/common/opportunities/utils/helpers/getTopOpportunitiesFittingCount";

export const SavingsOpportunitiesTopOpportunities: FC = () => {
  const [groupBy, setGroupBy] =
    useState<AllPossibleTopOpportunitiesOptionsType>("service");
  const [componentWidth, setComponentWidth] = useState<number | undefined>(
    undefined,
  );
  const fittingItemsCount = getTopOpportunitiesFittingCount(componentWidth);

  const handleWidthChange = useCallback((width: number) => {
    setComponentWidth(width);
  }, []);

  const groupedData = useAppSelector((state) =>
    savingsOpportunitiesTopOpportunitiesGroupedDataSelector(
      state,
      groupBy,
      fittingItemsCount,
    ),
  );

  return (
    <TopOpportunities
      groupBy={groupBy}
      setGroupBy={setGroupBy}
      groupedData={groupedData}
      subject="Savings Opportunities"
      topOpportunitiesOptions={topOptions}
      onWidthChange={handleWidthChange}
    />
  );
};

export const topOptions: Partial<
  Record<AllPossibleTopOpportunitiesOptionsType, string>
> = {
  service: "Service",
  action_type: "Opportunity Type",
  "account.provider_account_id": "Account",
  region: "Region",
  cloud_provider: "Cloud Provider",
};
